import { render } from "./BuscarOrden.vue?vue&type=template&id=2ed5eb09&scoped=true"
import script from "./BuscarOrden.vue?vue&type=script&lang=js"
export * from "./BuscarOrden.vue?vue&type=script&lang=js"

import "./BuscarOrden.vue?vue&type=style&index=0&id=2ed5eb09&scoped=true&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed5eb09"]])

export default __exports__